module.exports = __webpack_public_path__ + "static/media/Bengaluru-college-Karnataka.2c9bb959.jpg";